export default __webpack_public_path__ + "static/media/mic.ea40a8e6.png";